var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleteIconBlack = function SvgDeleteIconBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10.59 2h4.15v1.65h-4.15zM5.38 22.41H20l.89-16.76H4.49Zm10.54-14h2v11.35h-2Zm-4.25 0h2v11.35h-2Zm-4.25 0h2v11.35h-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.33 3.65h-8.59V0H8.59v3.65H0v2h2.48l1 18.76h18.37l1-18.76h2.48ZM10.59 2h4.15v1.65h-4.15ZM20 22.41H5.38L4.49 5.65h16.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.41 8.42h2v11.34h-2zM11.67 8.42h2v11.34h-2zM15.92 8.42h2v11.34h-2z"
  })));
};
export default SvgDeleteIconBlack;